export const fontWeight = {
  fontBold: "600",
  fontThin: "400",
};
